import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useChatContext } from '../../context/ChatContext';
import ThemeSpinner from '../general/ThemeSpinner';
import Inbox from './Inbox';
import ChatThreads from './chatThreads';

const MessageWrapper = () => {

    const { chatRoom, chatThread, setChatRoom } = useChatContext()
    const [isMobileView, setIsMobileView] = useState(false);
    const [showChatOnMobile, setShowChatOnMobile] = useState(false);

    // Check if screen is mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // When chat room is selected on mobile, show chat view
    useEffect(() => {
        if (!_.isEmpty(chatRoom) && isMobileView) {
            setShowChatOnMobile(true);
        }
    }, [chatRoom, isMobileView]);

    // Function to go back to thread list on mobile
    const handleBackToThreads = () => {
        setShowChatOnMobile(false);
        setChatRoom({});
    };

    return (
        <div className={"Layout"}>
            <Row className={"row"}>
                {/* Chat Threads Column - Hide on mobile when chat is open */}
                <Col
                    xs={12}
                    sm={12}
                    md={chatThread?.isLoading ? 12 : 4}
                    lg={chatThread?.isLoading ? 12 : 4}
                    className={`col ${isMobileView && showChatOnMobile ? 'd-none' : ''}`}
                >
                    {
                        chatThread?.isLoading ?
                            <ThemeSpinner /> :
                            <ChatThreads />
                    }
                </Col>

                {/* Chat Inbox Column - Show only when chat is selected */}
                <Col
                    xs={12}
                    sm={12}
                    md={8}
                    lg={8}
                    className={`col ${isMobileView && !showChatOnMobile ? 'd-none' : ''}`}
                >
                    {_.isEmpty(chatRoom) ? <></> :
                        <Inbox
                            key={chatRoom?.slug || ''}
                            isMobile={isMobileView}
                            onBack={handleBackToThreads}
                        />
                    }
                </Col>

            </Row>
        </div>
    )
}

export default MessageWrapper;